import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import * as React from 'react';
import { InputContainer } from './InputContainer.js';
import { InputInput } from './InputInput.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className", "emailStyle", "endAdornment", "focusRef", "InputComponent", "lightStyle", "onClick", "startAdornment", "style", "success"];
var Input = /*#__PURE__*/React.forwardRef(function Input2(props, ref) {
  var className = props.className,
    _props$emailStyle = props.emailStyle,
    emailStyle = _props$emailStyle === void 0 ? false : _props$emailStyle,
    endAdornment = props.endAdornment,
    focusRef = props.focusRef,
    _props$InputComponent = props.InputComponent,
    InputComponent = _props$InputComponent === void 0 ? "input" : _props$InputComponent,
    _props$lightStyle = props.lightStyle,
    lightStyle = _props$lightStyle === void 0 ? false : _props$lightStyle,
    onClick = props.onClick,
    startAdornment = props.startAdornment,
    style = props.style,
    success = props.success,
    rest = _objectWithoutProperties(props, _excluded);
  var containerProps = {
    disabled: rest.disabled,
    emailStyle: emailStyle,
    endAdornment: endAdornment,
    error: rest.error,
    focusRef: focusRef,
    lightStyle: lightStyle,
    onClick: onClick,
    readOnly: rest.readOnly,
    startAdornment: startAdornment,
    style: style,
    success: success
  };
  return /*#__PURE__*/jsx(InputContainer, _objectSpread(_objectSpread({
    className: classNames("_mntl-input", className)
  }, containerProps), {}, {
    children: /*#__PURE__*/jsx(InputInput, _objectSpread(_objectSpread({
      as: InputComponent
    }, rest), {}, {
      ref: ref
    }))
  }));
});
Input.displayName = "Input";

export { Input };
